const staging = "rzp_test_PChbEfOPed5cIV";
const prod = "rzp_live_uSbOpxaxtGBKeU";
// export default process.env.REACT_APP_BUILD_ENV === "production"
//   ? prod
//   : staging;

export default prod;
